module.exports = __webpack_public_path__ + "static/media/art_404.c8b41073.svg";